<template>

    <div v-show="showFilters" class="one-row one-row-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp -search-with-filters mb-4rem with-flexible-parts lw-cols align-items-center">
        <div class="col span_8_of_12 span_8_of_12-tl span_12_of_12-tp mb-2rem-tp span_12_of_12-sl mb-2rem-sl span_12_of_12-sp mb-2rem-sp lw-filters-wrapper no-padding flex-item">
            <div class="learnworlds-button-wrapper lw-filters with-flexible-parts horizontal learnworlds-align-left flex align-items-center lw-content-block learnworlds-element">
                <template v-for="option in filtersConfig">
                    <div class="learnworlds-main-text filter learnworlds-main-text-small filter"
                         v-if="shouldBeDisplayed(option,'button') && option.translatedLabel"
                         @click="primaryFilterApplied(option.filteringKey)"
                         :class="primaryFilterSelectedClass(option.filteringKey)"
                    >
                        {{option.translatedLabel}}
                    </div>

                    <div class="lw-filter-option with-submenu learnworlds-main-text learnworlds-main-text-small filter"
                         v-if="shouldBeDisplayed(option,'dropdown')"
                         :class="primaryFilterSelectedClass(option.filteringKey)"
                    >

                    <span class="js-filter-author-list">
                        <span class="lw-filter-option-lbl">{{ optionLabel(option) }} </span>
                    </span>

                        <ul class="lw-topbar-submenu lw-body-bg">
                            <li class="lw-topbar-submenu-item filter"
                                v-for="item in option.dataSource"
                                v-if="item.value !== selectedSecondaryFilter "
                                @click="secondaryFilterApplied(option.filteringKey,item.value)"
                            >
                                {{item.label}}
                            </li>
                        </ul>
                    </div>

                </template>
            </div>
        </div>

        <div class="-search-box col span_4_of_12 span_4_of_12-tl span_12_of_12-tp span_12_of_12-sl span_12_of_12-sp no-padding" v-if="searchInputDisplay">
            <div class="lw-cols learnworlds-input-wrapper with-input-cols align-items-stretch no-gutter one-row one-row-tl one-row-tp one-row-sl one-row-sp">
                <div class="col no-padding span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp flex-item flexible">
                    <form @submit.prevent="">
                        <input class="full-height learnworlds-input learnworlds-input-outline-brand learnworlds-input-small learnworlds-element"
                               :placeholder="$t('course.search_for_courses')"
                               type="text"
                               ref="searchInput"
                               @input="inputFilterApplied"
                               v-model="searchTermValue">
                    </form>
                </div>
                <div class="col no-padding span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp flex-item flexible">
                    <button class="only-icon learnworlds-button learnworlds-button-outline-brand learnworlds-element full-size learnworlds-button-small">
                        <span class="learnworlds-icon fas fa-search"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseCardsFilters3",
        mixins: [ComponentTemplatesMixin],
        data () {
            return {
                filterAppearance : {
                    "byAll" : "button",
                    "byMyCourses" : "button",
                    "byNew" : "button",
                    "byPopular" : "button",
                    "byFree" : "button",
                    "byCategory" : "dropdown",
                    "byAuthor" : "dropdown",
                    "bySubscription" : "dropdown",
                    "byBundle" : "dropdown",
                    "bySearchTerm" : "input",
                }
            }
        },
        props: {
            filtersConfig : {
                type: Object,
            },
            disabledFilters: {
                type: Array,
            },
            searchTermValue : {
                type: String
            },
            selectedPrimaryFilter : {
                type:  String
            },
            selectedSecondaryFilter : {
                type:  String
            },
            showFilters: {
                type: Boolean
            }
        },
        computed: {
            searchInputDisplay () {
                return !!this.filtersConfig.find(option => option.filteringKey === "bySearchTerm" && this.shouldBeDisplayed(option, 'input'));
            },
        },
        methods : {
            optionLabel (option) {
                return this.selectedPrimaryFilter === option.filteringKey && this.selectedSecondaryFilter ? option.dataSource.find(item => item.value === this.selectedSecondaryFilter).label : option.translatedLabel;
            },
            shouldBeDisplayed (option,type) {
                return  (   this.filterAppearance[option.filteringKey] === type || typeof this.filterAppearance[option.filteringKey] === "undefined" && type === 'button' ) &&
                            option.filterAvailable && this.filterEnabled(option.filteringKey);
            },
            primaryFilterApplied (primaryKey) {
                this.emitAction('primary-filter-applied',primaryKey);
            },
            inputFilterApplied (event) {
                this.secondaryFilterApplied('bySearchTerm',event.target.value);
            },
            secondaryFilterApplied (primaryKey,secondaryKey) {
                this.emitAction('secondary-filter-applied',{primaryKey,secondaryKey});
            },
            primaryFilterSelectedClass (filterKey) {
                return this.selectedPrimaryFilter === filterKey ? 'border-bottom' : 'text-only';
            },
            filterEnabled (filterKey) {
                return this.disabledFilters && !this.disabledFilters.includes(filterKey);
            },
        },
        watch: {
            searchTermValue () {
                //had to force this, for some weird reason v-model wouldnt empty the input
                if (!this.searchTermValue) {
                    this.$refs.searchInput.value = "";
                } else if (this.$refs.searchInput.value !== this.searchTermValue){
                    this.$refs.searchInput.value = this.searchTermValue;
                }
            }
        }
    }
</script>

